import { render, staticRenderFns } from "./MetadadosCampoDinamicoHora.vue?vue&type=template&id=89ec978a&"
import script from "./MetadadosCampoDinamicoHora.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoHora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoHora.vue
// module id = 1342
// module chunks = 28